import { makeQuery } from "src/queries/makeQuery";
import type {
  PipelineDetails,
  PipelineMinimal,
  PipelineV2,
} from "src/queries/pipelines/pipeline.types";

// Only include timeWindow if app_name isn't provided (i.e., listing all pipelines)
export const useQueryPipelines = makeQuery<PipelineV2[] | PipelineMinimal[]>(
  (p) => `/api/envs/${p.env_name}/pipelines`,
  {
    queryParams: [
      "appOwners",
      "appTags",
      "is_debug_mode",
      { timeWindow: (p) => (!p.app_name ? p.timeWindow : undefined) },
    ],
  }
);

export const useQueryPipelineDetails = makeQuery<PipelineDetails>(
  (p) => `/api/envs/${p.env_name}/apps/${p.app_name}`,
  { queryParams: ["timeWindow"] }
);
